module.exports = __webpack_public_path__ + "static/media/cases_ident_visual_bd_03.b1a56267.jpg";